import {
    AbstractDataState,
    hasFetchedSuccessfully,
    useGetContractBasedApiData,
} from '@cp-shared-15/frontend-integration';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';
import { useMemo } from 'react';
import { DealerCallbackDataSelector } from './DealerCallbackDataSelector';
import { fetchDealerCallback } from './DealerCallbackSlice';
import { useContract } from '../../contracts/useContract';
import { DealerCallback } from './types';

export function useDealerCallback(
    contractNumber: string,
): AbstractDataState<DealerCallback, DefaultBusinessMarketApiErrorCode> {
    const contractState = useContract(contractNumber);
    const dealerCallbackState = useGetContractBasedApiData(
        contractNumber,
        fetchDealerCallback,
        DealerCallbackDataSelector,
        `/early-settlement/${contractState.data?.encryptedContractNumber ?? ''}/dealer-callback`,
    );

    return useMemo(
        () => ({
            isLoading: contractState.isLoading || dealerCallbackState.isLoading,
            hasReceivedResponse: contractState.loadingError
                ? contractState.hasReceivedResponse
                : contractState.hasReceivedResponse && dealerCallbackState.hasReceivedResponse,
            failedLoadingAttempts: hasFetchedSuccessfully(contractState)
                ? dealerCallbackState.failedLoadingAttempts
                : contractState.failedLoadingAttempts,
            data: dealerCallbackState.data,
            loadingError: hasFetchedSuccessfully(contractState)
                ? dealerCallbackState.loadingError
                : contractState.loadingError,
        }),
        [contractState, dealerCallbackState],
    );
}
